<template>
  <div class="">
    <el-card class="box-card">
      <!-- <div class="search-form" style="text-align: left">
        <el-form ref="searchForm" :inline="true" :model="searchForm" label-width="100px" label-position="left"
          class="demo-form-inline" size="small">
          <el-form-item label="	{{ $t('invoice.invoice.addressType') }}">
            <el-select v-model="searchForm.type" :placeholder="$t('invoice.invoice.placeholder.selectAddressType')">
              <el-option :label="$t('invoice.invoice.senderAddress')" :value="1"></el-option>
              <el-option :label="$t('invoice.invoice.recipientAddress')" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">{{ $t('invoice.invoice.button.query') }}</el-button>
            <el-button icon="el-icon-refresh-right" type="primary" size="small" @click="resetSearch">{{ $t('invoice.invoice.button.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div> -->
      <el-table :data="dataList" border size="small" height="600">
        <el-table-column type="index" :index="indexMethod" :label="$t('invoice.invoice.serialNumber')" width="60"></el-table-column>
        <el-table-column prop="order_sn" :label="$t('invoice.invoice.orderNo')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="platform_order_sn" :label="$t('invoice.invoice.waybillNo')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createtime" :label="$t('invoice.invoice.createTime')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="action" :label="$t('invoice.invoice.operation')" width="140">
          <template slot-scope="scope">
            <div>
              <span style="color: #409eff; cursor: pointer" @click="handleDetail(scope.row)">{{ $t('invoice.invoice.viewInvoice') }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagization-box">
        <CustomPagization
          :background="true"
          :currentPage="current"
          :total="total"
          :pageSize="size"
          @current-change="currentChange"
        />
      </div>
    </el-card>

    <!-- 表单弹窗 -->
        <el-dialog
      :close-on-click-modal="false"
      title="Order Invoice"
      append-to-body
      :visible.sync="detailVisible"
      width="1200px"
      :before-close="closeDialog"
    >
      <DetailWrapper
        ref="formModal"
        :id="id"
        :platform_order_sn="platformOrderSn"
        v-if="detailVisible"
        append-to-body
      />
    </el-dialog>
  </div>
</template>

<script>
import { invoiceList } from '@/api/invoice'
import DetailWrapper from './detailWrapper.vue';
export default {
  components: {
    DetailWrapper
  },
  data() {
    return {
      detailVisible: false,
      id: '',
      platformOrderSn: '',
      searchForm: {},
      current: 1,
      size: 20,
      total: 1,
      dataList: [],
    };
  },
  mounted(){
    this.getAddress()
  },
  methods: {
    // 获取列表
    getAddress(){
      invoiceList({
        user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        page: this.current,
        limit: this.size,
        ...this.searchForm
      }).then(res => {
        if(res.code == 1){
          this.dataList = []
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.id = '';
      this.platformOrderSn = '';
      this.detailVisible = false;
    },
    //视频监控站点修改
    handleDetail(item) {
      this.id = item.id
      this.platformOrderSn = item.platform_order_sn || ''
      this.detailVisible = true
    },
    // table首列序号
    indexMethod(index) {
      return (this.current - 1) * this.size + index + 1;
    },
    // 页数变化
    currentChange(current) {
      this.current = current;
      this.getAddress();
    },
    // 重置筛选
    resetSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchForm = {}
      this.value1 = []
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.handleSearch();
    },
    // 去筛选
    handleSearch() {
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.getAddress();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
</style>